(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.recaptcha'
  const templateUrl = require('./tpl/recaptcha.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('angular-recaptcha')
    ])
    .run(recaptchaConfig)

  recaptchaConfig.$inject = ['formlyConfig', 'SdkConfig']
  function recaptchaConfig (formlyConfig, SdkConfig) {
    formlyConfig.setType({
      name: 'recaptcha',
      templateUrl: templateUrl,
      defaultOptions: {
        templateOptions: {
          recaptchaKey: SdkConfig.get('recaptcha_key'),
          lang: SdkConfig.get('language')
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      controller: recaptchaController
    })
  }

  recaptchaController.$inject = []
  function recaptchaController () {

  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/recaptcha.js